
export type UpdateDraftLectureMarkdown200 = {
  draftId?: number;
  lectureId?: number;
  /** @nullable */
  markdownUrl?: string | null;
  message?: string;
};
